import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'

import AnimationLayout from '../../components/AnimationLayout'
import { updateAvatar, getLockedAchievements } from '../../store/actions/apiActions'
import Button from '../../components/Button'
import Modal from 'react-modal'

import moment from 'moment'
import 'moment/locale/pt'
moment.locale('pt')

const Profile = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const ownUserProfile = useSelector(state => state?.firebase?.profile)
    const otherUserProfile = useSelector(state => state.apiCalls.apiData.user)
    const isOwnUserProfile = otherUserProfile?.username ? false : true
    const userProfile = !otherUserProfile ? ownUserProfile : otherUserProfile
    const { favoriteCountries, username, avatar, inventory, experience, experiencePercentage, comments, advices, travelBook, studyGame, achievements, travels, statute, level } = userProfile
    const completedTravelsItems = travels.completedTravels.filter((item) => !item.includes('initial-cutscene'))

    let checkIfHasHat = avatar.split('-')
    let currentHat = checkIfHasHat.length === 4 ? `${checkIfHasHat[1]}-${checkIfHasHat[2]}` : null

    const [state, setState] = useState({
        isOpen: false,
        currentAvatar: ownUserProfile?.avatar,
        chosenExpression: checkIfHasHat[checkIfHasHat.length - 1],
        chosenHat: !currentHat ? null : currentHat
    })

    const mainProfileLinks = [
        [isOwnUserProfile ? 'Os meus itens' : 'Itens', `${location.pathname}/itens`, 'menu-inventory'],
        ['Caderneta de viagens', `${location.pathname}/caderneta-de-viagens`, 'menu-album'],
        ['Proezas', `${location.pathname}/proezas`, 'menu-achievements'],
    ]

    const matildeExpressions = [
        'angry', 'bored', 'happy', 'hello', 'impressed', 'normal', 'sad', 'scary', 'sleepy', 'thinking', 'tired'
    ]

    const { isOpen, chosenExpression, chosenHat } = state

    return (
        <AnimationLayout>
            <div id='profile' className='grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mb-12'>
                <div className='flex flex-wrap'>
                    <Button
                        className='flex justify-center image-button usable mr-0 w-full'
                        style={{ cursor: isOwnUserProfile ? 'pointer' : 'default' }}
                        onClick={() => isOwnUserProfile ? setState({ ...state, isOpen: !isOpen }) : null}
                    >
                        <img
                            style={{ maxHeight: 225 }}
                            className='object-contain'
                            alt={username}
                            title={username}
                            src={require(`../../assets/img/matilde-faces/${avatar}.png`)}
                        />
                        {isOwnUserProfile && <h6 className='text-center pb-0'>Editar aparência</h6>}
                    </Button>
                </div>
                <div className='lg:col-span-2'>
                    <h1 className='w-full pb-2'>{username}</h1>
                    <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 pb-3'>
                        <div>
                            <h4 className='pb-0'>Nível: <span>{level}</span></h4>
                            <p className='pb-2'>Para o próximo nível:</p>
                            <div data-label={`${experiencePercentage}%`} className="profileProgress">
                                <span style={{ width: `${experiencePercentage}%` }} className="value"></span>
                            </div>
                        </div>

                    </div>

                    <div className='pb-3'>
                        <h4 className='pb-1'>Estatuto:</h4>
                        <span>{statute}</span>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mb-12">
                {mainProfileLinks.map((item, index) =>
                    <Link key={index}
                        to={{
                            pathname: item[1],
                            state: {
                                from: location.pathname,
                                profile: userProfile
                            }
                        }}
                        onClick={() => item[0] === 'Proezas' ? dispatch(getLockedAchievements()) : null}
                    >
                        <Button className='image-button h-full usable py-4 mr-0'>
                            <img alt={item[0]} className='object-contain mb-4' src={`${require(`../../assets/img/${item[2]}.png`)}`} />
                            <h4 className='pb-0'>{item[0]}</h4>
                        </Button>
                    </Link>
                )}
            </div>

            <div className='mb-12'>
                <h3>Social</h3>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mb-12">

                    <div className='flex flex-col'>
                        <h5 className='pb-2'>Países favoritos:</h5>
                        {!favoriteCountries.length ?
                            isOwnUserProfile ?
                                <p>Ainda não adicionou qualquer país à sua lista de países favoritos</p> :
                                <p>Este utilizador não adicionou qualquer país à sua lista de países favoritos</p>
                            :
                            favoriteCountries.map((item, index) =>
                                <span key={index}>{item.name}</span>
                            )
                        }
                    </div>

                    <div className='flex flex-col'>
                        <h5 className='pb-2'>Último comentário:</h5>
                        {!comments.length ?
                            isOwnUserProfile ?
                                <p>Ainda não submeteu qualquer comentário no Adventour</p> :
                                <p>Este utilizador não submeteu qualquer comentário no Adventour</p>
                            :
                            comments[comments.length - 1] &&
                            <div>
                                <span>{moment(comments[comments.length - 1]?.date).fromNow()}</span>
                                <p className='truncate'>{comments[comments.length - 1].comment}</p>
                            </div>
                        }
                    </div>

                    <div className='flex flex-col'>
                        <h5 className='pb-2'>Último conselho:</h5>
                        {!advices.length ?
                            isOwnUserProfile ?
                                <p>Ainda não submenteu qualquer conselho no Adventour</p> :
                                <p>Este utilizador não submeteu qualquer conselho no Adventour</p>
                            :
                            advices[0] &&
                            <div>
                                <span>{moment(advices[0].date).fromNow()}</span>
                                <p className='truncate'>{advices[0].advice}</p>
                            </div>
                        }
                    </div>

                </div>
            </div>

            <div className='mb-12'>
                <h3>{isOwnUserProfile ? 'As suas estatísticas' : 'Estatísticas deste utilizador'}</h3>
                <div className="white-container grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8 mb-12">
                    <div className='flex flex-col'>
                        <h5>Proezas conquistadas: <span>{achievements?.length}</span></h5>
                        <h5>Itens adquiridos: <span>{inventory?.bag.length}</span></h5>
                        <h5>Pontos de experiência adquiridos: <span>{experience}</span></h5>
                    </div>
                    <div className='flex flex-col'>
                        <h5>Mundo em notícias realizados: <span>{studyGame}</span></h5>
                        <h5>Viagens realizadas: <span>{completedTravelsItems.length}</span></h5>
                        <h5>Fotos capturadas: <span>{travelBook?.length}</span></h5>
                    </div>
                </div>
            </div>


            {isOwnUserProfile &&
                <Modal
                    isOpen={isOpen}
                    contentLabel="Modal das Configurações"
                    className='modal'
                    ariaHideApp={false}
                    closeTimeoutMS={300}
                    shouldCloseOnOverlayClick={true}
                    disableAutoFocus={true}
                    onRequestClose={() => setTimeout(() => {
                        setState({ ...state, isOpen: !isOpen })
                    }, 300)}
                >
                    <div className="modal-guts">
                        <div className='flex flex-1 flex-wrap justify-between items-center'>
                            <h2>Editar aparência</h2>
                        </div>
                        <h3>Escolha a expressão que quer no seu avatar:</h3>
                        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-10'>
                            {matildeExpressions.map((item, index) => {
                                return (
                                    <Button
                                        key={index}
                                        onClick={() => setState({ ...state, chosenExpression: item })}
                                        className={`${chosenExpression.includes(item) && 'active'} image-button usable flex justify-center mr-0`}
                                    >
                                        <img
                                            alt={`Matilde ${item}`}
                                            title={`Matilde ${item}`}
                                            style={{ height: 85, width: 60 }}
                                            src={!chosenHat ?
                                                require(`../../assets/img/matilde-faces/matilde-${item}.png`) :
                                                require(`../../assets/img/matilde-faces/matilde-${chosenHat}-${item}.png`)
                                            }
                                        />
                                    </Button>
                                )
                            }
                            )}
                        </div>

                        <h3>Escolha o chapéu que quer utilizar:</h3>
                        <div>
                            {inventory?.hats && !inventory?.hats.length ?
                                <p>Ainda não tem qualquer tipo de chapéu no seu guarda-chapéus para personalizar o seu avatar.</p>
                                :
                                <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-10'>
                                    <Button
                                        onClick={() => setState({ ...state, chosenHat: null })}
                                        className={`${!chosenHat && 'active'} flex justify-center image-button usable`}
                                    >
                                        <p>Retirar chapéu</p>
                                    </Button>
                                    {inventory?.hats && inventory?.hats.map((item) =>
                                        <Button
                                            key={item.name}
                                            onClick={() => setState({ ...state, chosenHat: item.img })}
                                            className={`${chosenHat && chosenHat.includes(item.img) && 'active'} flex justify-center image-button usable`}
                                        >
                                            <img
                                                alt={item.name}
                                                title={item.name}
                                                style={{ height: 85, width: 85 }}
                                                src={require(`../../assets/img/hats/${item.img}.png`)}
                                            />
                                        </Button>
                                    )}
                                </div>

                            }
                        </div>

                        <div className='py-8 flex justify-end'>
                            <Button
                                onClick={() => setTimeout(() => {
                                    setState({ ...state, isOpen: !isOpen })
                                }, 300)}
                            >
                                Fechar
                        </Button>
                            <Button
                                className='mr-0'
                                onClick={() => setTimeout(() => {
                                    setState({ ...state, isOpen: !isOpen })
                                    dispatch(updateAvatar(chosenExpression, chosenHat))
                                }, 300)}
                            >
                                Salvar
                        </Button>
                        </div>
                    </div>
                </Modal>
            }

        </AnimationLayout>
    )
}

export default Profile